import React from 'react';
import { Col, Row, View } from '@amzn/stencil-react-components/layout';
import { Label, H2, H3 } from '@amzn/stencil-react-components/text';
import { useApplicationContext } from './context/ApplicationContext';
import { getEnvironmentStage, getStageSpecificCognitoAuthSettings } from '../util/envUtils';
import { CognitoAuth } from 'amazon-cognito-auth-js';
import { STAGES } from '../constants/urlConstants';

export const LogoutPage = props => {
  const appContext = useApplicationContext();
  const stage = getEnvironmentStage();
  if (stage !== STAGES.UNKNOWN_STAGE) {
    const authData = getStageSpecificCognitoAuthSettings(stage);
    const cognitoAuthorizer = new CognitoAuth(authData);
    cognitoAuthorizer.signOut();
  }
  return (
    <View data-testid="logout" gridGap={'S500'} padding={'15px'}>
      <H2>You have been logged out.</H2>
    </View>
  );
};
